var _desc, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "password") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(204 -137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "password"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    transform: "translate(-203.255 137)",
    fill: "#868686"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    fillRule: "evenodd",
    d: "M 1.40481 8.84953L 16.9469 8.84953C 17.7195 8.84953 18.3517 9.48174 18.3517 10.2545L 18.3517 18.5953C 18.3517 19.3678 17.7195 20 16.9469 20L 1.40481 20C 0.632205 20 -1.39834e-08 19.3678 -1.39834e-08 18.5953L -1.39834e-08 10.2543C -1.39834e-08 9.48162 0.632083 8.84953 1.40481 8.84953ZM 10.7728 13.3069C 10.7728 11.4027 7.57864 11.4324 7.57864 13.3069C 7.57864 13.9608 7.84892 14.2445 8.26216 14.5097C 8.18091 14.9322 8.24665 16.0107 8.24665 16.5011C 8.24665 17.6343 9.95986 17.6339 9.95986 16.5011C 9.95986 15.9344 10.0097 15.1238 9.9557 14.5868C 10.4434 14.3357 10.7728 13.9866 10.7728 13.3069ZM 12.5152 7.87984C 12.5151 1.53946 5.83623 1.58089 5.83635 7.99067C 4.72333 7.99067 3.61019 7.99067 2.49717 7.99067C 2.49717 -2.62559 15.8544 -2.66432 15.8544 7.87984C 14.7415 7.87984 15.8544 7.87984 12.5152 7.87984Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.285e55a2f3f3617959ec4cf3a13663fa.svg";
export { ForwardRef as ReactComponent };